<template>
  <div v-if="key != ''" class="pt-3">
    <vue-recaptcha :sitekey="key" :loadRecaptchaScript="true" @verify="onVerify"></vue-recaptcha>
    <slot v-if="robot"></slot>
    <div v-else class="captcha-disabled"><slot></slot></div>
  </div>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';
  export default {
    props: ['recaptcha_sitekey'],
    components: { VueRecaptcha },
    data() {
      return {
        key: '',
        robot: false,
      }
    },
    mounted() {
      this.key = this.recaptcha_sitekey;
    },
    methods: {
      onVerify: function (response) {
        if (response) this.robot = true;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .captcha-disabled {
    pointer-events: none;
    opacity: 0.7;
    cursor: not-allowed;
  }
</style>
